import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "pt-0" }
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "flex flex-wrap items-center justify-between space-y-2" }
const _hoisted_6 = { class: "text-2xl font-medium md:text-3xl" }
const _hoisted_7 = { class: "w-full my-3" }
const _hoisted_8 = { class: "flex flex-wrap items-center justify-between mt-16 space-y-2" }
const _hoisted_9 = { class: "text-3xl font-medium capitalize" }
const _hoisted_10 = { class: "text-3xl font-medium capitalize" }
const _hoisted_11 = { class: "w-full overflow-x-auto" }
const _hoisted_12 = { class: "w-full mt-4 table-auto" }
const _hoisted_13 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_15 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_17 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_18 = {
  scope: "col",
  class: "px-2 py-2 sr-only"
}
const _hoisted_19 = { class: "px-2 py-3 capitalize whitespace-nowrap" }
const _hoisted_20 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_21 = { class: "px-2 py-2 whitespace-nowrap" }
const _hoisted_22 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_23 = { class: "px-2 py-2 whitespace-nowrap" }
const _hoisted_24 = {
  key: 0,
  class: "mt-16"
}
const _hoisted_25 = { class: "text-3xl font-medium capitalize" }
const _hoisted_26 = { class: "w-full overflow-x-auto" }
const _hoisted_27 = { class: "w-full mt-4 table-auto" }
const _hoisted_28 = { class: "font-bold text-left capitalize border-b-2 border-black" }
const _hoisted_29 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_30 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_31 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_32 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_33 = { class: "px-2 py-3 capitalize" }
const _hoisted_34 = { class: "px-2 py-2 capitalize" }
const _hoisted_35 = { class: "px-2 py-2 capitalize" }
const _hoisted_36 = { class: "px-2 py-2 whitespace-nowrap" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TemplateBlock from "@/components/TemplateBlock.vue";
import RouterButton from "@/components/RouterButton.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { Template, Booking, Event } from "@/types";
import AlertCard from "@/components/AlertCard.vue";
import { deserializeSlug } from "@/utils/slugify";
import UserBookingsTable from "@/components/tables/UserBookingsTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplatesIndex',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());
const templates = ref([] as Template[]);
const events = ref([] as Event[]);
const bookings = ref([] as Booking[]);
const ownBookings = ref([] as Booking[]);

const actions = ref(
  {} as {
    bookings: Booking[];
  }
);

const bookingRoles = [
  "professional",
  "paid-professional",
  "certified-facilitator-trainee",
  "certified-facilitator",
  "advanced-facilitator-trainee",
  "advanced-facilitator",
  "trainer-organisation",
  "facilitator-organisation",
  "l4a-trainee",
];

const adminRoles = ["admin", "courses-admin"];

if (adminRoles.some(role => user.value.roles.some(userRole => userRole.name === role))) {
  const coursesApi = (
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplates("all"))),
  __temp = await __temp,
  __restore(),
  __temp
);
  templates.value = coursesApi.data.templates;
}

if (adminRoles.some(role => user.value.roles.some(userRole => userRole.name === role))) {
  const eventsApi = (
  ([__temp,__restore] = _withAsyncContext(() => api.events.listEvents({
    page: 1,
    upcoming: true,
    status: "published",
  }))),
  __temp = await __temp,
  __restore(),
  __temp
);
  events.value = eventsApi.data.events;
}

let orgRoles = ["trainer-organisation", "facilitator-organisation"];

// If user is a TO or FO, get events in their Organisation
if (user.value.roles.find(i => orgRoles.includes(i.name))) {
  const eventsApi = (
  ([__temp,__restore] = _withAsyncContext(() => api.events.listEvents({
    page: 1,
    upcoming: true,
    status: "published",
  }))),
  __temp = await __temp,
  __restore(),
  __temp
);
  events.value = eventsApi.data.events;

  // Remove duplicate bookings where event_id is the same
  ownBookings.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.listOwnBookings({ page: 1, include_added_by_user: true }))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.bookings.filter(
    (booking, index, self) => index === self.findIndex(b => b.event?.id === booking.event?.id)
  );
}

// If user is a trainer, get events they are assigned to
if (user.value.roles.find(i => i.name === "l4a-trainer")) {
  const eventsApi = (
  ([__temp,__restore] = _withAsyncContext(() => api.events.listUserEvents(String(1), user.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
);
  events.value = eventsApi.data.events;
}

// If user is a booking user, get their bookings
if (bookingRoles.some(role => user.value.roles.some(userRole => userRole.name === role))) {
  /** Lists bookings where user is user_id on bookings */
  bookings.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.listOwnBookings({ page: 1, include_added_by_user: false }))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.bookings;

  const actionsApi = (
  ([__temp,__restore] = _withAsyncContext(() => api.actions.listUserActions())),
  __temp = await __temp,
  __restore(),
  __temp
);
  actions.value = actionsApi.data.actions;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (actions.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value.bookings, (booking, index) => {
              return (_openBlock(), _createBlock(AlertCard, {
                type: "warning",
                hideIcon: true,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, [
                      _createTextVNode(" To attend the "),
                      _createElementVNode("strong", null, _toDisplayString(booking.event!.name), 1),
                      _createTextVNode(" course, please accept our mandatory course prerequisites. ")
                    ]),
                    _createVNode(RouterButton, {
                      to: { name: 'Course_Prerequisites', params: { id: booking.id } },
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Course prerequisites")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(TitleHeader, {
        class: "mt-4",
        title: _ctx.$t('courses')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("latest-course-templates")), 1),
            _createVNode(RouterButton, {
              to: { name: 'Course-Templates' },
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("see-all-course-templates")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value.slice(0, 2), (template) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "px-4 py-2 border first:rounded-t last:rounded-b border-gray-50",
                key: template.id
              }, [
                _createVNode(TemplateBlock, { template: template }, null, 8, ["template"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(RoleGuard, { roles: ['admin', 'l4a-trainer', 'courses-admin', 'trainer-organisation', 'facilitator-organisation'] }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'trainer-organisation', 'facilitator-organisation'] }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("upcoming-training-events")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("events-in-your-organisation")), 1)
              ]),
              _: 1
            }),
            _createVNode(RoleGuard, { roles: ['l4a-trainer'] }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("your-training-events")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("events-you-are-assigned-to")), 1)
              ]),
              _: 1
            }),
            _createVNode(RouterButton, {
              to: { name: 'Training_Events' },
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("see-all-training-events")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(RoleGuard, { roles: ['admin', 'l4a-trainer', 'courses-admin', 'trainer-organisation', 'facilitator-organisation'] }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_13, [
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("event-name")), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("course-type")), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("location")), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("delivery-date")), 1),
                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("view")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value.slice(0, 4), (event) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b border-gray-400 even:bg-gray-200",
                  key: event.id
                }, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(event.name) + " (#" + _toDisplayString(event.id) + ")", 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(deserializeSlug)(event.type)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(event.template.delivery !== "in-person" ? _ctx.$t("online") : event.city), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(event.first_event_date ? new Date(event.first_event_date).toDateString() : _ctx.$t("no-date-available")), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: `/dashboard/courses/events/${event.id}`,
                      class: "text-blue"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['professional', 'paid-professional', 'certified-facilitator-trainee', 'certified-facilitator', 'advanced-facilitator-trainee', 'advanced-facilitator', 'l4a-trainee'] }, {
      default: _withCtx(() => [
        _createVNode(UserBookingsTable)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['trainer-organisation', 'facilitator-organisation'] }, {
      default: _withCtx(() => [
        (ownBookings.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t("your-bookings")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("your-bookings-description")), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_28, [
                      _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("event-name")), 1),
                      _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t("course-type")), 1),
                      _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("status")), 1),
                      _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("actions")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ownBookings.value, (booking) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "border-b border-gray-400 even:bg-gray-200",
                        key: booking.id
                      }, [
                        _createElementVNode("td", _hoisted_33, _toDisplayString(booking.event!.name), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(booking.event?.type === "continual-professional-development" ? booking.event?.type.split("-").join(" ") : booking.event?.type), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(booking.user_attended ? "Complete" : "In Progress"), 1),
                        _createElementVNode("td", _hoisted_36, [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/courses/events/${booking.event!.id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})